import React from "react";
import { useEffect, useState } from 'react';
import { Form, Button, Table, Col, Row, Container, Card } from 'react-bootstrap';
import { capitalizeFirstLetter, CharacterCount, validateRecords } from '../Shared/Helpers';
import { v4 as uuidv4 } from 'uuid';
import { isEmpty } from "lodash";
import SweetAlert from "react-bootstrap-sweetalert";
import ReactDatetime from "react-datetime";

const StepSix = ({ handleNext, handleBack, storedData, stepNum, jobType }) => {

    const [file, setFile] = useState(null);
    const [errors, setErrors] = useState({});

    const [referees, setReferees] = useState([
        { name: "", companyName: "", occupation: "", contactNo: "" },
        { name: "", companyName: "", occupation: "", contactNo: "" },
    ]);

    const handleRefereeChange = (index, field, value) => {
        const updatedRecord = {
            ...referees[index],
            [field]: value
        };
        const updatedRecords = [...referees];
        updatedRecords[index] = updatedRecord;
        setReferees(updatedRecords);
    };

    const handleCapitalWord = (index, field, value) => {
        handleRefereeChange(index, field, capitalizeFirstLetter(value));
    };

    function handleFileUpload(event) {
        const newFile = event.target.files[0];
        const maxSize = 5 * 1024 * 1024; // 5 MB
        if (newFile && newFile.size > maxSize) {
            alert("File size is too large. Maximum file size allowed is 5MB.");
            event.target.value = null; // clear the file input
            return;
        }
        setFile(newFile);
    }

    const handleNextCommand = () => {
        try {


            if (showReferee) {
                const logErrors = validateRecords(referees, null);

                if (!Object.values(logErrors).some(Boolean)) {
                    setErrors([]);
                    handleNext(referees); // pass data
                } else {
                    setErrors(logErrors);
                }
            }

            handleNext(referees); // pass data
        } catch (e) {
            console.log(e);
        }
    };

    // ## HOOKS ##
    useEffect(() => {
        if (!isEmpty(storedData)) {
            setReferees(storedData);
        }
    }, []);

    // was added as we arent looking for refeeres untill sucessfull
    const [showReferee, setshowReferee] = useState(false);
    return (
        <Row>
            <Col sm={12} md={12}>
                <h2 >{stepNum} Referees</h2>


                <Form.Label style={{ textAlign: 'left' }}>
                    You will be asked to provide contact details of two people, one of whom should be able to comment on aspects of your employment if an offer is being made.
                </Form.Label>
            </Col>



            {showReferee && (
                <div>
                    <Col md={6}>
                        <Card style={{ backgroundColor: "#fafafa  " }}>
                            <Card.Body>
                                <Card.Title>
                                    <Form.Label>Referee 1<span className="star">*</span></Form.Label>
                                </Card.Title>
                                <Form.Group controlId="referee1Name">
                                    <Form.Label>Full Name:</Form.Label>
                                    <Form.Control
                                        type="text"
                                        maxLength="100"
                                        className={errors[`name${0}`] ? "form-control is-invalid custom-input" : "form-control custom-input"}
                                        name="name"
                                        value={referees[0].name}
                                        onBlur={(e) => handleCapitalWord(0, 'name', e.target.value)}
                                        onChange={(e) => {
                                            handleRefereeChange(0, 'name', e.target.value);
                                            if (errors[`name${0}`]) {
                                                setErrors({ ...errors, [`name${0}`]: "" });
                                            }
                                        }}
                                    />
                                    {errors[`name${0}`] && <p className="text-danger"> {errors[`name${0}`]} <span className="star">*</span> </p>}
                                </Form.Group>
                                <Form.Group controlId="referee1Company">
                                    <Form.Label>Company:</Form.Label>
                                    <Form.Control
                                        type="text"
                                        maxLength="100"
                                        className={errors[`companyName${0}`] ? "form-control is-invalid custom-input" : "form-control custom-input"}
                                        name="company"
                                        value={referees[0].companyName}
                                        onBlur={(e) => handleCapitalWord(0, 'companyName', e.target.value)}
                                        onChange={(e) => {
                                            handleRefereeChange(0, 'companyName', e.target.value);
                                            if (errors[`companyName${0}`]) {
                                                setErrors({ ...errors, [`companyName${0}`]: "" });
                                            }
                                        }}
                                    />
                                    {errors[`companyName${0}`] && <p className="text-danger"> {errors[`companyName${0}`]} <span className="star">*</span> </p>}
                                </Form.Group>
                                <Form.Group controlId="referee1Occupation">
                                    <Form.Label>Occupation:</Form.Label>
                                    <Form.Control
                                        type="text"
                                        maxLength="100"
                                        className={errors[`occupation${0}`] ? "form-control is-invalid custom-input" : "form-control custom-input"}
                                        name="occupation"
                                        value={referees[0].occupation}
                                        onBlur={(e) => handleCapitalWord(0, 'occupation', e.target.value)}
                                        onChange={(e) => {
                                            handleRefereeChange(0, 'occupation', e.target.value);
                                            if (errors[`occupation${0}`]) {
                                                setErrors({ ...errors, [`occupation${0}`]: "" });
                                            }
                                        }}
                                    />
                                    {errors[`occupation${0}`] && <p className="text-danger"> {errors[`occupation${0}`]} <span className="star">*</span> </p>}
                                </Form.Group>
                                <Form.Group controlId="referee1Contact">
                                    <Form.Label>Contact Number:</Form.Label>
                                    <Form.Control
                                        type="text"
                                        maxLength="20"
                                        className={errors[`contactNo${0}`] ? "form-control is-invalid custom-input" : "form-control custom-input"}
                                        name="contactNo"
                                        value={referees[0].contactNo}
                                        onChange={(e) => {
                                            handleRefereeChange(0, 'contactNo', e.target.value);
                                            if (errors[`contactNo${0}`]) {
                                                setErrors({ ...errors, [`contactNo${0}`]: "" });
                                            }
                                        }}
                                    />
                                    {errors[`contactNo${0}`] && <p className="text-danger"> {errors[`contactNo${0}`]} <span className="star">*</span> </p>}
                                </Form.Group>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={6}>
                        <Card style={{ backgroundColor: "#fafafa  " }}>
                            <Card.Body>
                                <Card.Title>
                                    <Form.Label>Referee 2<span className="star">*</span></Form.Label>
                                </Card.Title>
                                <Form.Group controlId="referee1Name">
                                    <Form.Label>Full Name:</Form.Label>
                                    <Form.Control
                                        type="text"
                                        maxLength="100"
                                        className={errors[`name${1}`] ? "form-control is-invalid custom-input" : "form-control custom-input"}
                                        name="name"
                                        value={referees[1].name}
                                        onBlur={(e) => handleCapitalWord(1, 'name', e.target.value)}
                                        onChange={(e) => {
                                            handleRefereeChange(1, 'name', e.target.value);
                                            if (errors[`name${1}`]) {
                                                setErrors({ ...errors, [`name${1}`]: "" });
                                            }
                                        }}
                                    />
                                    {errors[`name${1}`] && <p className="text-danger"> {errors[`name${1}`]} <span className="star">*</span> </p>}
                                </Form.Group>
                                <Form.Group controlId="referee1Company">
                                    <Form.Label>Company:</Form.Label>
                                    <Form.Control
                                        type="text"
                                        maxLength="100"
                                        className={errors[`companyName${1}`] ? "form-control is-invalid custom-input" : "form-control custom-input"}
                                        name="company"
                                        value={referees[1].companyName}
                                        onBlur={(e) => handleCapitalWord(1, 'companyName', e.target.value)}
                                        onChange={(e) => {
                                            handleRefereeChange(1, 'companyName', e.target.value);
                                            if (errors[`companyName${1}`]) {
                                                setErrors({ ...errors, [`companyName${1}`]: "" });
                                            }
                                        }}
                                    />
                                    {errors[`companyName${1}`] && <p className="text-danger"> {errors[`companyName${1}`]} <span className="star">*</span> </p>}
                                </Form.Group>
                                <Form.Group controlId="referee1Occupation">
                                    <Form.Label>Occupation:</Form.Label>
                                    <Form.Control
                                        type="text"
                                        maxLength="100"
                                        className={errors[`occupation${1}`] ? "form-control is-invalid custom-input" : "form-control custom-input"}
                                        name="occupation"
                                        value={referees[1].occupation}
                                        onBlur={(e) => handleCapitalWord(1, 'occupation', e.target.value)}
                                        onChange={(e) => {
                                            handleRefereeChange(1, 'occupation', e.target.value);
                                            if (errors[`occupation${1}`]) {
                                                setErrors({ ...errors, [`occupation${1}`]: "" });
                                            }
                                        }}
                                    />
                                    {errors[`occupation${1}`] && <p className="text-danger"> {errors[`occupation${1}`]} <span className="star">*</span> </p>}
                                </Form.Group>
                                <Form.Group controlId="referee1Contact">
                                    <Form.Label>Contact Number:</Form.Label>
                                    <Form.Control
                                        type="text"
                                        maxLength="20"
                                        className={errors[`contactNo${1}`] ? "form-control is-invalid custom-input" : "form-control custom-input"}
                                        name="contact"
                                        value={referees[1].contactNo}
                                        onChange={(e) => {
                                            handleRefereeChange(1, 'contactNo', e.target.value);
                                            if (errors[`contactNo${1}`]) {
                                                setErrors({ ...errors, [`contactNo${1}`]: "" });
                                            }
                                        }}
                                    />
                                    {errors[`contactNo${1}`] && <p className="text-danger"> {errors[`contactNo${1}`]} <span className="star">*</span> </p>}
                                </Form.Group>
                            </Card.Body>
                        </Card>
                    </Col>
                </div>
            )}

            {/*<Col md={12}>*/}
            {/*    <h5>CV Upload (Optional):</h5>*/}
            {/*    <div className="file-upload-container">*/}
            {/*        <label htmlFor="file-upload" className="file-upload-label">*/}
            {/*            <i className="fas fa-cloud-upload-alt file-upload-icon"></i>*/}
            {/*            {file ? file.name : 'Click Here To Upload File'}*/}
            {/*            <p>Files Supported: PDF, DOC, DOCX.</p>*/}
            {/*        </label>*/}
            {/*        <input*/}
            {/*            id="file-upload"*/}
            {/*            type="file"*/}
            {/*            accept=".pdf, .doc, .docx"*/}
            {/*            onChange={handleFileUpload}*/}
            {/*            className="file-upload-input"*/}
            {/*        />*/}
            {/*    </div>*/}
            {/*</Col>*/}


            <Row>
                <Col sm={12} className="d-flex justify-content-between mt-3">
                    <Button className="btn-lg btn-shadow" variamt="danger" onClick={handleBack}>Back</Button>
                    <Button className="btn-lg btn-shadow" variant="success" onClick={handleNextCommand}>Next</Button>
                </Col>
            </Row>
        </Row>
    );
}

export default StepSix;
